import React from "react";
import { useNavigate } from "react-router-dom";
import FacebookConnectPage from "./FacebookConnectPage";

const PartnerConnect: React.FC = () => {
  const navigate = useNavigate();
  return (
    <FacebookConnectPage
      title="Connect your business to Caucus"
      configId={process.env.REACT_APP_PARTNER_CONFIG_ID!}
      onCode={(code) =>
        navigate("/facebookManage", { state: { authCode: code, authType: "partner" } })
      }
    />
  );
};

export default PartnerConnect;
